// extracted by mini-css-extract-plugin
export var button = "CTA-module--button--4275d";
export var chevronRight = "CTA-module--chevronRight--5a25e";
export var description = "CTA-module--description--6e9f7";
export var icon = "CTA-module--icon--4d7d2";
export var itemsContainer = "CTA-module--itemsContainer--05f40";
export var itemsContent = "CTA-module--itemsContent--bffe4";
export var label = "CTA-module--label--1a3d3";
export var link = "CTA-module--link--33843";
export var wrapper = "CTA-module--wrapper--359cb";